import React, { useState, useEffect, useContext } from "react";
import { Spinner } from "reactstrap";
import Axios from "axios";
import { BASE_URL_API } from "infra/config";
import Appbar from "ui/layouts/default/components/Appbar";
import styled from "styled-components";
import { navigate } from "infra/router/history";
import { LayoutContext } from "contexts/layout";

const Body = styled.div`
  padding-top: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media all and (max-width: 768px) {
    padding-top: 30px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #e6e7ea;
  margin-top: 8px;
  padding: 16px;
  text-align: center;
  gap: 16px;
`;

const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #e6e7ea;
  margin-top: 8px;
  padding: 16px;
`;

const NumeroMesa = styled.div`
  font-weight: bold;
  color: #067847;
  font-size: 18px;
`;

const NomeEmpresa = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

const EnderecoEmpresa = styled.div`
  font-size: 12px;
`;

const Message = styled.div`
  font-weight: bold;
  color: #4e4e4e;
  font-size: 16px;
`;

const AccessMenuButton = styled.button`
  background-color: #ef2b2d;
  color: white;
  border-color: #ef2b2d;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  padding: 4px;
  width: 100%;
  &:hover {
    background-color: #d0282a;
  }
`;

const EmpresaInfo = ({ nome, logradouro, numero, cidade }) => (
  <ContainerHeader>
    <NomeEmpresa>{nome}</NomeEmpresa>
    <EnderecoEmpresa>{`${logradouro}, ${numero}, ${cidade}`}</EnderecoEmpresa>
  </ContainerHeader>
);

const LoadingIndicator = () => (
  <Container>
    <h3>Consultando...</h3>
    <Spinner style={{ margin: "32px auto" }} />
  </Container>
);

const MesaInfo = ({ mesa, iniciarPedido }) => (
  <Container>
    {mesa.flgAceitaPedido ? (
      <>
        <NumeroMesa>{mesa.identificacaoVenda}</NumeroMesa>
        <Message>{mesa.mensagem}</Message>
        <AccessMenuButton onClick={iniciarPedido}>
          Iniciar Pedido
        </AccessMenuButton>
      </>
    ) : (
      <>
        <Message>{mesa.mensagem}</Message>
        <AccessMenuButton onClick={iniciarPedido}>
          Acessar Cardápio
        </AccessMenuButton>
      </>
    )}
  </Container>
);

function RedirectQRCodeMesa({ match }) {
  const [isLoading, setIsLoading] = useState(false);
  const { layoutData } = useContext(LayoutContext);
  const [mesa, setMesa] = useState(null);

  useEffect(() => {
    const fetchMesaData = async () => {
      setIsLoading(true);
      try {
        const { data } = await Axios.get(
          `${BASE_URL_API}/v3/wg-pedido-comanda/busca-dados-mesa?chave=${
            match.params.codigoMesa || ""
          }`
        );
        setMesa(data);
      } catch (error) {
        console.error("Erro ao buscar dados da mesa", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMesaData();
  }, [match.params.codigoMesa]);

  const iniciarPedido = () => {
    if (mesa) {
      localStorage.setItem("chaveCns", mesa.chaveMobilePedido);
      localStorage.setItem("conta", mesa.saidaId);
      navigate("menu", true);
    }
  };
  const acessarCardapio = () => {
    if (mesa) {
      localStorage.setItem("chaveCns", undefined);
      localStorage.setItem("conta", undefined);
      navigate("menu", true);
    }
  };

  return (
    <Body>
      <Appbar />
      {layoutData && (
        <EmpresaInfo
          nome={layoutData.nome}
          logradouro={layoutData.endLogradouro}
          numero={layoutData.endNumero}
          cidade={layoutData.endCidadeNome}
        />
      )}
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        mesa && (
          <MesaInfo
            mesa={mesa}
            iniciarPedido={
              !mesa.flgAceitaPedido ? acessarCardapio : iniciarPedido
            }
          />
        )
      )}
    </Body>
  );
}

export default RedirectQRCodeMesa;
